import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { DictationPluginInterface } from './plugin/DictationPlugin';
import { DictationStore, getDictationStore } from './store/store';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "DictationPlugin" */ './lazyIndex')
);

export let LazyDictationPluginClass = createLazyPlugin(
    lazyModule,
    m => m.DictationPlugin,
    'Dictation',
    null
);

export type LazyDictationPlugin = LazyPlugin<DictationPluginInterface>;
export { DictationStore, getDictationStore };
